/* c8 ignore start */
import { i18n } from "@/i18n.js";
import { SIDENAV_GROUP_BY } from "@/constants";
import { SAT_SERVICE } from "@/utils/services";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

const MSP_NAV_ITEMS = [
  {
    order: 2,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-security-awareness-training"),
    name: "msp-security_awareness_training",
    icon: "cl-icon-tabler-school",
    id: buildOrgUrl("msp", null, "security_awareness_training"),
    dataTestId: "msp-security_awareness_training",
    solutionId: SAT_SERVICE,
    children: [
      {
        label: i18n.global.t("sidebar-overview"),
        id: buildOrgUrl("msp", null, "security_awareness_training/overview"),
        dataTestId: "msp-security_awareness_training-overview",
      },
      {
        label: i18n.global.t("sidebar-sat-campaigns"),
        id: buildOrgUrl(
          "msp",
          null,
          "security_awareness_training/sat_campaigns",
        ),
        dataTestId: "msp-security_awareness_training-sat_campaigns",
      },
    ],
  },
];

export { MSP_NAV_ITEMS };

const CUSTOMER_NAV_ITEMS = [
  {
    order: 2,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-security-awareness-training"),
    icon: "cl-icon-tabler-school",
    id: buildOrgUrl("customer", null, "security_awareness_training"),
    dataTestId: "customer-security_awareness_training",
    solutionId: SAT_SERVICE,
    children: [
      {
        label: i18n.global.t("sidebar-overview"),
        id: buildOrgUrl(
          "customer",
          null,
          "security_awareness_training/overview",
        ),
        dataTestId: "customer-security_awareness_training-overview",
      },
      {
        label: i18n.global.t("sidebar-sat-campaigns"),
        id: buildOrgUrl(
          "customer",
          null,
          "security_awareness_training/sat_campaigns",
        ),
        dataTestId: "customer-security_awareness_training-sat_campaigns",
      },
      {
        label: i18n.global.t("sidebar-content-manager"),
        id: buildOrgUrl(
          "customer",
          null,
          "security_awareness_training/content_manager",
        ),
        dataTestId: "customer-security_awareness_training-content_manager",
      },
    ],
  },
];

export { CUSTOMER_NAV_ITEMS };

/* c8 ignore end */
